import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defineMessages } from 'react-intl';

import Colours from '../definitions/Colours';
import Sizes from '../definitions/Sizes';
import PrimaryButton from './PrimaryButton';
import Caption from './Caption';


function InputCompleteButton({ onClick, showEnterText, 'data-name': dataName, ...otherProps }) {
    return (
        <Container {...otherProps}>
            <PrimaryButton
                className="button"
                type="button"
                size="small"
                variant="mint-dark"
                message={MESSAGES.BUTTON_LABEL_DEFAULT}
                onClick={onClick}
                data-name={dataName}

                /* This button is not important to have in the tab
                    flow since keyboard users would either press enter
                    or tab to complete the input. */
                tabIndex="-1"
            />
            <If condition={showEnterText}>
                <Caption
                    className="enter-text"
                    message={MESSAGES.ENTER_TEXT}
                />
            </If>
        </Container>
    );
}

InputCompleteButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    showEnterText: PropTypes.bool,
    'data-name': PropTypes.string,
};

InputCompleteButton.defaultProps = {
    showEnterText: true,
    'data-name': 'InputCompleteButton',
};

const Container = styled.div`
    display: flex;
    align-items: center;

    > .button {
        width: fit-content;
    }

    > .enter-text {
        color: ${Colours.STONE_DARKEST};
        margin: 0 ${Sizes.SPACING.ONE};
    }
`;

const MESSAGES = defineMessages({
    BUTTON_LABEL_DEFAULT: {
        id: 'base-ui.InputCompleteButton.buttonText',
        defaultMessage: 'Next',
    },
    ENTER_TEXT: {
        id: 'base-ui.InputCompleteButton.enterText',
        defaultMessage: 'Or press <strong>enter</strong>',
    },
});

export default InputCompleteButton;
